import { createSlice, PayloadAction } from '@reduxjs/toolkit'

const initialState = false

const firstApplySlice = createSlice({
  name: 'savedModalOpen',
  initialState,
  reducers: {
    setFirstApply(_state, action: PayloadAction<boolean>) {
      if (action.payload) {
        return action.payload
      }
      return initialState
    },
  },
})

export const { setFirstApply } = firstApplySlice.actions
export default firstApplySlice.reducer
